import ScheduleCalendar from './ScheduleCalendar';

export default ScheduleCalendar;
